import { filterAvailableTypes, getManureTypeColor, getManureTypeNVzNitrogen, getRegionFilter, isBlendType, setupManureTypesForRegion } from "../shared/manure";

export const manure = {
    getManureTypeNVzNitrogen,
    getManureTypeColor,
    filterAvailableTypes,
    setupManureTypesForRegion,
    isBlendType,
    getRegionFilter
}